export default __webpack_public_path__ + "static/media/H4002.1.40786aa3.mp3";